/**
 * The analyzers' "Main providers" / "Main sites" start on the account's identity (CU-869fmm949, Curro 2026-10-28):
 * Settings › Account (`GET /api/user/identity`, MASTER_USER_CONFIG `main_provider_ids` / `main_site_ids` — the same
 * identity Iris and the dashboards read). An empty field gets the first own id its list offers (brands in their
 * saved order: the primary first); the user can still change it or clear it, and a cleared field stays empty until
 * the context changes (a new execution, pass, search or office). Pure: no React, no signals — `node --test` runs it.
 */

const num = (v) => {
	const n = Number(v)
	return Number.isFinite(n) ? n : null
}

const isEmpty = (v) => v == null || v === '' || (Array.isArray(v) && !v.length)

/** The identity's ids (`identity.js` `fromApi` shape), in their saved order. */
export function ownIds(identity) {
	const ids = (list) => (Array.isArray(list) ? list : []).map(x => num(x?.id)).filter(n => n != null)
	return { providers: ids(identity?.providers), sites: ids(identity?.sites) }
}

/** The value to put in an empty field, or `null`: the first own id present in the field's options. */
export function ownDefault({ current, own = [], options = [], dismissed = false }) {
	if (dismissed || !isEmpty(current) || !own?.length || !Array.isArray(options) || !options.length) return null
	for (const id of own) {
		const hit = options.find(o => o && num(o.value) != null && num(o.value) === num(id))
		if (hit) return hit.value
	}
	return null
}

/** What a clear belongs to: a new execution, pass, search or office opens the field to the default again. */
export const contextKey = ({ report = null, pass = null, searchID = null, office = null } = {}) =>
	[report, pass, searchID, office].map(v => (v == null ? '' : String(v))).join('|')

/** The clear button of the field sends `null`; the list dropping a value it no longer offers sends `''`
 *  (`@ui-seeker/core` `AutocompleteAjaxSeeker`). Only the first is the user's. */
export const isUserClear = (value) => value === null
